export const specializationMap = {
  accepted_insurance: 'insurance',
  accepts_insurance: 'insurance',
  activity: 'activities',
  activities: 'activities',
  amenity: 'amenities',
  amenities: 'amenities',
  price: 'price',
  setting: 'setting',
  treatment_method: 'approach',
  treatment_services: 'care',
  treatment_therapies: 'therapies',
  treatment_therapy: 'therapies',
  what_we_treat: 'condition',
  who_we_treat: 'clientele'
} as const

export const mapTaxonomyToRoute = (
  type: keyof typeof specializationMap | string,
  slug: string
): string => {
  const mappedType = specializationMap[type]
  if (mappedType) {
    return `/${mappedType}/${slug}/`
  }
  return null
}
